<div class="user-profile" *ngIf="model.user">
  <div class="custom-dropdown" (clickOutside)="model.open = false">
    <a
      class="selected-item"
      [ngClass]="{ open: model.open }"
      tabindex
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="true"
      (click)="openItems()"
      fxFlex
      fxLayoutAlign="start center"
    >
      <div
        class="thumb image"
        *ngIf="model.user.thumb"
        fxFlex="34px"
        fxLayoutAlign="center center"
      >
        <img src="../../../../assets/images/profile.jpg" />
      </div>
      <div
        class="thumb"
        [ngStyle]="{
          'background-color': model.user.attributes.color
            ? model.user.attributes.color[0]
            : '#000'
        }"
        *ngIf="!model.user.thumb"
        fxFlex="34px"
        fxLayoutAlign="center center"
      >
        {{ model.firstLetter }}
      </div>
      <div class="description-box">
        <div class="description">
          <div class="label">
            {{ model.user.firstName + " " + model.user.lastName }}
          </div>
        </div>
        <div class="description email h-large">
          <div class="label">
            {{ model.user.email }}
          </div>
        </div>
      </div>
      <span class="select-partner-arrow">
        <svg
          width="10"
          class="svg-inline--fa fa-chevron-down fa-w-14"
          role="img"
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="chevron-down"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
          ></path>
        </svg>
      </span>
    </a>
    <div class="custom-dropdown-items" [ngClass]="{ show: model.open }">
      <div class="item-wrap" *ngFor="let item of menu">
        <a
          class="item"
          *ngIf="item.enabled"
          [routerLink]="[item.configs.url]"
          (click)="model.open = false"
          >{{ item.configs.title | translate }}</a
        >
      </div>
      <a class="item exit" (click)="logout()">{{
        "menu.user.logout" | translate
      }}</a>
    </div>
  </div>
</div>
